import React from "react";
import Popover, { PopoverProps } from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core";
import { Classes, ThemeType } from "@theme";

type Props = {
  children: React.ReactElement<any>;
  classes: Classes<typeof styles>;
  in?: boolean;
  isStatic?: boolean;
  popoverContent?: React.ReactNode | (() => React.ReactNode);
  PopoverProps?: Omit<PopoverProps, "open">;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
};

type State = {
  anchor: HTMLElement | null;
};

class WithPopover extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    in: true
  };

  state: State = {
    anchor: null
  };

  element = null;

  componentDidMount = () => {
    if (this.props.isStatic) {
      this.setState({ anchor: this.element });
    }
  };

  handleOpen = (e: React.SyntheticEvent<any>) => {
    if (this.state.anchor || this.props.isStatic) {
      return;
    }

    this.setState({ anchor: e.currentTarget });
  };

  handleClose = () => {
    if (!this.state.anchor || this.props.isStatic) {
      return;
    }

    this.setState({ anchor: null });
  };

  render() {
    const { popoverContent } = this.props;
    const { anchor } = this.state;

    if (!this.props.in || !popoverContent) {
      return this.props.children;
    }

    const isOpen = Boolean(anchor);

    const _popoverContent =
      typeof popoverContent === "function" ? popoverContent : () => popoverContent;

    return (
      <>
        <div
          onMouseOver={(e) => this.handleOpen(e)}
          onMouseLeave={() => this.handleClose()}
          ref={(ref) => {
            this.element = ref;
          }}
          {...this.props.wrapperProps}
        >
          {this.props.children}
        </div>

        <Popover
          {...this.props.PopoverProps}
          hideBackdrop
          // style={{ po}}
          anchorEl={anchor}
          className={this.props.classes.popover}
          classes={{
            paper: this.props.classes.paper
          }}
          disableAutoFocus
          disableRestoreFocus
          open={isOpen}
          onClose={this.handleClose}
        >
          {isOpen ? _popoverContent() : null}
        </Popover>
      </>
    );
  }
}

const styles = (theme: ThemeType) => ({
  paper: {
    padding: theme.spacing()
  },

  popover: {
    pointerEvents: "none"
  }
});

export default withStyles(styles as any)(WithPopover);
